import {
  useCreateStoreItemTagMutation,
  useCreateStoreItemTagsBulkMutation,
  useDeleteStoreItemTagMutation,
  useGetStoreItemTagsQuery,
} from "@/graphql";
import { computed } from "vue";

export default function useTags(gameId: string, queryParams?: { type: string }) {
  const { result, refetch: refetchTags } = useGetStoreItemTagsQuery({ gameId, type: queryParams?.type });
  const { mutate: createStoreItemTag } = useCreateStoreItemTagMutation({});
  const { mutate: createStoreItemTagsBulk } = useCreateStoreItemTagsBulkMutation({});
  const { mutate: deleteStoreItemTag } = useDeleteStoreItemTagMutation({});

  const createTag = async (name: string) => {
    try {
      const response = await createStoreItemTag({ gameId, input: { name, type: queryParams?.type } });
      await refetchTags();
      return response?.data?.createStoreItemTag;
    } catch (error) {
      console.error(`Error creating tag '${name}':`, error);
      throw error;
    }
  };

  const createTagsBulk = async (tags: { name: string }[]) => {
    try {
      const response = await createStoreItemTagsBulk({ gameId, input: tags });
      await refetchTags();
      return response?.data?.createStoreItemTagsBulk;
    } catch (error) {
      console.error("Error creating tags in bulk:", error);
      throw error;
    }
  };

  const deleteTag = async (tagId: string) => {
    try {
      await deleteStoreItemTag({ gameId, tagId });
      await refetchTags();
    } catch (error) {
      console.error(`Error deleting tag with ID '${tagId}':`, error);
      throw error;
    }
  };

  const tags = computed(() => result.value?.getStoreItemTags ?? []);

  return {
    tags,
    createTag,
    createTagsBulk,
    refetchTags,
    deleteTag,
  };
}
